import React from 'react'
import { IconProps } from '../../../common/types'

const MaterialDownloadIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19.0518L16 15.0518H13.5V12.0518H10.5V15.0518H8L12 19.0518Z"
        fill="black"
      />
      <path
        d="M13.5 3.05176L19 8.55176V20.0518C19 20.6018 18.55 21.0518 18 21.0518H6C5.45 21.0518 5 20.6018 5 20.0518V4.05176C5 3.50176 5.45 3.05176 6 3.05176H13.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 3.55176V8.05176H19L14.5 3.55176Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MaterialDownloadIcon
